var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex justify-content-center" }, [
    _c("div", { staticClass: "datasource-wrap" }, [
      _c("div", { staticClass: "card-content card-datasource" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list-datasource" },
          _vm._l(_vm.dummyData, function(data, index) {
            return _c(
              "div",
              { key: data.title + "-" + index, staticClass: "datasource" },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icon-sidebar/data-manager.svg")
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "wrap-title-datasource" }, [
                    _c("p", { staticClass: "datasource-name ellipsis" }, [
                      _vm._v(_vm._s(data.title))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "datasource-date" }, [
                      _vm._v(_vm._s(data.timestamp))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-ellipsis-v toggle-popover",
                  attrs: { id: "popover-datasource-" + index }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "total-table" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(data.total_table) +
                      "\n            "
                  ),
                  _c("span", [_vm._v("tables")])
                ])
              ]
            )
          })
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-with-add" }, [
      _c("p", { staticClass: "card-title" }, [_vm._v("Data Source")]),
      _vm._v(" "),
      _c("p", { staticClass: "btn-add" }, [
        _c("i", { staticClass: "fa fa-plus" }),
        _vm._v(" Add\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a81bd46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a81bd46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/jDataSourceTab.vue
// module id = null
// module chunks = 